export default function Cursor() {
	return <div className="h-3 w-3 rounded-full bg-gray-500" />;
}
